export const STAGE_VARIANT = {
  success: "success",
  warning: "warning",
  error: "error",
} as const;

export type StageVariant = (typeof STAGE_VARIANT)[keyof typeof STAGE_VARIANT];
